module.exports = __webpack_public_path__ + "static/jigyo2-8aa609793901d5ef3f13d60612f1b44a.jpg";